import React, { useEffect, useMemo, useState } from 'react'
import { debounce, get } from 'lodash'
import BreadCrumb from '../../../components/BreadCrumb';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import Table from '../../../components/CustomTable';
// import { options, } from './constant'
import routes from '../../../routes';
import { Link, withRouter } from 'react-router-dom';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { configAttributeAction, getAdvertiserAndCampaignFilterListAction, getFeeSettingListAllAction, getFeeSettingsFilterListAction, postFilterFeeSettingAction, postGetbyIdFeeSettingAction } from '../../../actions';
import { useFetchPlatformData } from '../../../hooks/useFetchPlatformData';
import { useFetchTenantsListData } from '../../../hooks/useFetchTenantsListData';
import { formFields } from '../List/constant';
import { handleFieldError } from '../../../utils/form-validation';
import { isApiCallSuccess } from '../../../selectors';
import { checkTablePermission } from '../../../utils/route-auth';
import { PERMISSION } from '../../../constants/permission';

const Card = asyncRoute(() => import('../../../components/Card'));
const Input = asyncRoute(() => import('../../../components/FormElements/Input'));

function ListFeeSettings(props) {
    const [feeSettingsListAllData, setFeeSettingsListAllData] = useState([])
    const [listFeeSettingData, setListFeeSettingData] = useState([])
    const [advertiserListOptions, setAdvertiserListOptions] = useState([{ label: 'All', value: -1 }])
    const [campaginListOption, setCampaginListOption] = useState([])
    const [advertiserFilter, setAdvertiserFilter] = useState({ label: 'All', value: -1 })
    const [campaignFilter, setCampaignFilter] = useState({})
    const [popoverVisible, setPopoverVisible] = useState(false)
    const [searchParams, setSearchParams] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [isSearchInputFocused, setIsSearchInputFocused] = useState(false);
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState({});
    const platformData = useFetchPlatformData()
    const tenantsData = useFetchTenantsListData();

    const options = useMemo(() => {
        return (
            checkTablePermission({ edit: PERMISSION.FEESETTING.FEESETTING.EDIT, view: PERMISSION.FEESETTING.FEESETTING.VIEW }, {
                columns: [
                    { id: 1, name: '', label: '', sortable: false, },
                    { id: 2, name: 'campaignId', label: 'CAMPAIGN ID', sortable: false, component: (row) => <div>{row.marginDetails && row.marginDetails.length > 0 && row.marginDetails[0].campaignId}</div> },
                    {
                        id: 3, name: 'advertiserId', label: 'ADVERTISER', sortable: false, type: 'string', component: (row) => (
                            <div>
                                {
                                    row.tenantSupported && row.tenantSupported === 0 ?
                                        'All' :
                                        (Array.isArray(advertiserListOptions) && advertiserListOptions.length > 0 && advertiserListOptions.find(item => item.value == row.advertiserId) ? advertiserListOptions.find(item => item.value == row.advertiserId).label : '-')
                                }
                            </div>
                        )
                    },
                    {
                        id: 4, name: 'campaignName', label: 'CAMPAIGN NAME', sortable: true, type: 'date',
                        //  component: (row) => moment(row.txnDateTime).format('DD-MMM-YY')
                    },
                    {
                        id: 5, name: 'platformId', label: 'PLATFORM', sortable: true, type: 'number', component: (row) => <div>
                            {
                                (Array.isArray(platformData) && platformData.length > 0 ? platformData.find(item => item.platformId == row.platformId) ? platformData.find(item => item.platformId == row.platformId).value : "-" : '')
                            }
                        </div>
                    },
                    { id: 6, name: 'platformCampaignName', label: 'PLATFORM CAMP NAME', sortable: true, type: 'string' },
                    { id: 7, name: 'status', label: 'STATUS', sortable: true, type: 'string', component: (row) => <div>{row.campaignStatus == "1" ? "Active" : row.campaignStatus == "2" ? "Paused" : row.campaignStatus == "0" ? "Inactive" : ''}</div> },
                    { id: 8, name: 'feeModel', label: 'FEE MODEL', sortable: true, type: 'number', component: (row) => <div>{row.feeModel == "0" ? "CPM" : row.feeModel == "1" ? "CPC" : row.feeModel == "2" ? "CPA" : row.feeModel == "3" ? "Advertiser Spend" : ''}</div> },
                    { id: 9, name: 'feeValue', label: 'FEE VALUE', sortable: false, type: 'number', component: (row) => <div>{row.feeType == 0 ? '-' : row.feeValue}</div> },
                    // { id: 3, name: 'strategyName', label: 'STRATEGY  NAME', sortable: true, type: 'string' },
                    // { id: 4, name: 'feeType', label: 'FEE TYPE', sortable: true, type: 'number', component: (row) => <div>{row.feeType == "0" ? "Fixed" : "Percentage"}</div> },
                    // { id: 4, name: 'txnCreditAmount', label: 'UPDATE PLATFORM', sortable: true, type: 'number' },
                    // { id: 5, name: 'txnCurrentBalance', label: 'ADD ON', sortable: false, type: 'number', },
                ],
                keyCol: 'ioNo',
                actionName: 'ACTIONS',
                actions: [
                    {
                        type: 'edit',
                        text: '',
                        icon: 'ti ti-pencil color-beki',
                        tooltip: 'Edit',
                        iconType: 'new'
                    },
                    {
                        type: 'view',
                        text: '',
                        icon: 'ti ti-eye color-beki',
                        tooltip: 'Edit',
                        iconType: 'new'
                    }
                ],
                recActive: false,
                actionsThead: true,
                sortable: true,
                dateType: true,
                defaultSortParams: {
                    sortBy: 'txnDateTime',
                    sortOrder: 'desc'
                },
                paging: true,
                defaultPagingParams: {
                    pageSize: 25
                }
            })
        )
    }, [platformData, advertiserListOptions]);


    const tenantId = useSelector((state) => get(state, 'app.preSignInState.tenantId', ''));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const dispatch = useDispatch();


    useEffect(() => {
        getListAdvCampData();
        getListALLFeeSettings();
        // console.log(props)
    }, [])

    // SEARCH
    // useEffect(() => {
    //     if (searchParams && searchParams.length > 3) {
    //         clearTimeout(searchTimeout);
    //         setSearchTimeout(setTimeout(() => filterFeeSettings(), 300));
    //     } else if (searchParams == '' && isSearchInputFocused) {
    //         filterFeeSettings();
    //     }
    // }, [searchParams]);

    const togglePopover = () => {
        setPopoverVisible(!popoverVisible);
    }

    const handleChange = (selected, name) => {
        if (name == "advertiser") {
            setAdvertiserFilter(selected)
        }
        // if (name == "campaign") {
        //     setCampaignFilter(selected)
        // }
    }

    const handleSearchChange = (e) => {
        const { name, value } = e.target;
        const newForm = { ...form };
        newForm[name] = value;
        if (name == formFields.search.key) {
            setIsSearchInputFocused(true);
            debouncedSearch(value);
        }
        setForm(newForm);
    };

    const debouncedSearch = debounce((searchParam) => {
        filterFeeSettings(searchParam);
    }, 800);

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const getListAdvCampData = async () => {
        // await dispatch(getAdvertiserAndCampaignFilterListAction({ tenantId, authToken, userId }))
        //     .then((data) => {
        //         const {
        //             responseCode: { status = "" },
        //             responseObj,
        //         } = data;
        //         if (status === "Success" && Object.keys(responseObj).length > 0) {
        //             const getAdvertiserList = responseObj && responseObj.hasOwnProperty('advertisers') && responseObj.advertisers.length > 0 && responseObj.advertisers.map((ele) => {
        //                 return {
        //                     label: ele.name,
        //                     value: ele.id
        //                 }
        //             })
        //             const getCampaignList = responseObj && responseObj.hasOwnProperty('campaigns') && responseObj.campaigns.length > 0 && responseObj.campaigns.map((ele) => {
        //                 return {
        //                     label: ele.name,
        //                     value: ele.id
        //                 }
        //             })

        //             setAdvertiserListOptions(getAdvertiserList)
        //             setCampaginListOption(getCampaignList)
        //         } else {
        //             console.log("Filter list not found");
        //         }
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //     });

        await dispatch(getFeeSettingsFilterListAction({ tenantId, authToken, userId }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    responseObj,
                } = data;
                if (isApiCallSuccess(status) && responseObj && responseObj.hasOwnProperty('advertiserList') && responseObj.advertiserList.length > 0) {
                    const advertisersListData = responseObj.advertiserList.map((ele) => {
                        return {
                            label: ele.value,
                            value: ele.key
                        }
                    });
                    setAdvertiserListOptions([...advertiserListOptions, ...advertisersListData]);
                    // setCampaginListOption(getCampaignList)
                } else {
                    console.log("Advertisers list filter not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const getListALLFeeSettings = async () => {
        await dispatch(getFeeSettingListAllAction({ tenantId, authToken, userId }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success" && response && response.length > 0) {

                    response.forEach((dataCmp) => {
                        dataCmp["disabledActions"] = [...(dataCmp["disabledActions"] ? dataCmp["disabledActions"] : [])];
                        if (dataCmp.hasOwnProperty("isEditable") && !dataCmp.isEditable) {
                            dataCmp["disabledActions"].push("ti ti-pencil color-beki")
                        }
                    })
                    setListFeeSettingData(response)

                } else {
                    console.log("fee setting List all not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const searchFeeSettingsList = async () => {
        // await dispatch(getFeeSettingListAllAction({ tenantId, authToken, userId }))
        //     .then((data) => {
        //         const {
        //             responseCode: { status = "" },
        //             response,
        //         } = data;
        //         if (status === "Success" && response && response.length > 0) {
        //             setListFeeSettingData(response)

        //         } else {
        //             console.log("fee setting List all not found");
        //         }
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //     });
    }

    const filterFeeSettings = async (searchParams, reset = false) => {
        try {
            let payload = {};
            if (Object.keys(advertiserFilter).length != 0
                && advertiserFilter.value != -1
                && !reset
                // || Object.keys(campaignFilter).length != 0
            ) {
                payload = {
                    filter: {
                        // campaignId: [+campaignFilter.value],
                        advId: [+advertiserFilter.value]
                    }
                }
            }

            if (searchParams && searchParams !== '') {
                if (payload.filter)
                    payload['filter']['searchStr'] = searchParams.trim();
                else {
                    payload['filter'] = {};
                    payload['filter']['searchStr'] = searchParams.trim();
                }
            }

            await dispatch(postGetbyIdFeeSettingAction({ tenantId, authToken, userId, payload }))
                .then((data) => {
                    const {
                        responseCode: { status = "" },
                        response,
                    } = data;
                    if (isApiCallSuccess(status)) {

                        response.forEach((dataCmp) => {
                            dataCmp["disabledActions"] = [...(dataCmp["disabledActions"] ? dataCmp["disabledActions"] : [])];
                            if (dataCmp && !dataCmp.isEditable) {
                                dataCmp["disabledActions"].push("ti ti-pencil color-beki")
                            }
                        })


                        setListFeeSettingData(response)
                        // setAdvertiserFilter({ label: 'All', value: -1 })
                        // setCampaignFilter({})
                        setPopoverVisible(false)
                    } else {
                        console.log("Fee Setting list response empty");
                        setListFeeSettingData([]);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        } catch (error) {
            console.log(error);
        }
    }

    const handleReset = () => {
        filterFeeSettings('', true);
        setAdvertiserFilter({ label: 'All', value: -1 });
        setPopoverVisible(false);
    }

    const handelAction = (row, action) => {
        const { history, match } = props
        const id = row.marginDetails && row.marginDetails.length > 0 && row.marginDetails[0].campaignId
        if (action.type == "edit") {
            history.push(`${match.path}/${routes.feeSettings.editFeeSettings}/${id}`)
        } else if (action.type == "view") {
            history.push(`${match.path}/${routes.feeSettings.viewFeeSettings}/${id}`);
        }
    }


    const { match } = props
    return (
        <>
            <div className="main-panel ion form__style">
                <div className="content-wrapper">
                    <BreadCrumb />
                    <div className="row mt-3">
                        <Card>

                            <div className='d-flex align-items-center justify-content-between mb-2'>
                                <div className='d-flex align-items-center  position-relative'>
                                    <button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }} className='btn' onClick={togglePopover}>
                                        <i className='ti ti-filter ti-sm'></i>
                                        Filters
                                    </button>

                                    {popoverVisible && (
                                        <div className='popover'>
                                            <div style={{ background: "#F7F8FC" }} className='d-flex justify-content-between align-items-center p-3'>
                                                <h5 style={{ fontWeight: 500, margin: 0 }}>Filters</h5>
                                                <button className='close close-popover' onClick={togglePopover}>
                                                    &times;
                                                </button>
                                            </div>

                                            <div className='row flex-column p-3'>

                                                <div className='col-md-12 mb-2'>
                                                    <label className='mb-2'>Select Advertisers/Agency</label>
                                                    <Select
                                                        options={advertiserListOptions}
                                                        isMulti={false}
                                                        defaultValue={advertiserFilter}
                                                        value={advertiserFilter}
                                                        onChange={(selected) => handleChange(selected, "advertiser")}
                                                        placeholder="-- Select Advertisers/Agency"
                                                    />
                                                </div>

                                                {/* <div className='col-md-12 mb-2'>
                                                    <label>Select Campaigns :</label>
                                                    <Select
                                                        options={campaginListOption}
                                                        isMulti={false}
                                                        defaultValue={campaignFilter}
                                                        value={campaignFilter}
                                                        onChange={(selected) => handleChange(selected, "campaign")}
                                                        placeholder="--Select--"
                                                    />
                                                </div> */}


                                                {/* Apply And Cancel button */}
                                                <div className="col-md-12 mt-4 justify-content-end d-flex">
                                                    <button
                                                        onClick={() => handleReset()}
                                                        className="btn btn-outline-primary">Reset</button>
                                                    <button type="submit"
                                                        onClick={(e) => filterFeeSettings(form[formFields.search.key], false)}
                                                        className="btn btn-primary bg-color-beki ml-3">Apply</button>
                                                </div>

                                            </div>
                                        </div>)}
                                </div>

                                <div className='d-flex align-items-center mt-2 ml-4 search-adj'>
                                    <i style={{ color: "#A4ABB5", fontSize: 12, }} className='ti ti-search ti-sm'></i>
                                    <Input
                                        onChange={handleSearchChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.search.key]}
                                        setting={formFields[formFields.search.key]}
                                        error={errors[formFields.search.key]}
                                        submited={submited}
                                        // disabled={true}
                                        touched={touched[formFields.search.key]} />
                                </div>
                            </div>



                            {/* {
                                (checkAddPermission(PERMISSION.MARGIN.MARGIN.ADD)) && (
                                <div className="margin-list-adj">
                                    <Link to={`${match.path}/${routes.feeSettings.addFeeSettings}`}> <button className="btn btn-primary"><i className="mdi mdi-plus"></i>Platform Fee</button></Link>
                                </div>
                                )

                            } */}


                            <div className=" mt-5 campaign-list-adj table-responsive SubcriptionTable">
                                <Table
                                    options={options}
                                    data={listFeeSettingData || []}
                                    handelAction={handelAction}
                                />
                            </div>

                        </Card>
                    </div>
                </div>
            </div>

        </>
    )
}

export default withRouter(ListFeeSettings)
